import { render, staticRenderFns } from "./ContactActions.vue?vue&type=template&id=20970324"
import script from "./ContactActions.vue?vue&type=script&lang=js"
export * from "./ContactActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports